import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

export default function Account(props) {
  const [formData, setFormData] = useState({
      firstname: "",
      lastname: "",
      email: "",
      password : "",
  })
  const [isBool, setBool] = useState(false);
  function handleChange(event) { 
    setFormData(prevFormData => {
        return {
            ...prevFormData,
            [event.target.name]: event.target.value
        }
    })

    if (event.target.name === 'password') {
      validatePassword(event.target.value);
    }
  }
  function validatePassword(password) {
    const elem = document.getElementById('floatingPassword')
    const letterRange = /[a-zA-Z]/;
    const numberRange = /[0-9]/;

    if (
      (password.length < 8 || password.length > 20) &&
      letterRange.test(password) ||
      !numberRange.test(password)
    ) {
      elem.classList.add('is-invalid');
      setBool(true);
    } else {
      elem.classList.remove('is-invalid');
      setBool(false);
    }
  }
  

  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      props.setSignedIn(true);
      props.setUsername(formData.firstname);
      navigate('/rewards');
    }

    setValidated(true);
  };

  return (
    <section id='account'>
      <h2>Create an account</h2>
      <p>Sign up now to earn points on every order, get access to member exclusive perks, and <a href='#/rewards'>more</a></p>
      <Container className='bg-body-tertiary rounded'>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group as={Col} className='form-group' controlId="validationCustom01">
              <FloatingLabel controlId="floatingInput" label="First name">
                <Form.Control
                    required
                    type="text"
                    placeholder="First name"
                    value={formData.firstname}
                    onChange={handleChange}
                    name='firstname'
                    defaultValue=""
                  />
                  <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  <Form.Control.Feedback type='invalid'>Enter your first name</Form.Control.Feedback>
              </FloatingLabel>
              <Form.Text id="emailHelpBlock" muted>
                This will be your username.
              </Form.Text>
            </Form.Group>
            <Form.Group as={Col} className='form-group' controlId="validationCustom02">
              <FloatingLabel label="Last name">
                <Form.Control
                  required
                  type="text"
                  placeholder="Last name"
                  value={formData.lastname}
                  onChange={handleChange}
                  name='lastname'
                  defaultValue=""
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                <Form.Control.Feedback type='invalid'>Enter your last name</Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
            <Form.Group as={Col} className='form-group' controlId="validationCustom04">
              <FloatingLabel label="Email address">
                <Form.Control
                  required
                  type="email"
                  placeholder="name@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  name='email'
                  defaultValue=""
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                <Form.Control.Feedback type='invalid'>Enter your email address</Form.Control.Feedback>
                <Form.Text id="emailHelpBlock" muted>
                  Your email address should resemble something like name@example.com
                </Form.Text>
              </FloatingLabel>
            </Form.Group>
            <Form.Group as={Col} className='form-group' controlId="validationCustom05">
              <FloatingLabel controlId="floatingPassword" label="Password">
                <Form.Control
                  required
                  type="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                  name='password'
                  defaultValue=""

                />
                {!isBool && <Form.Control.Feedback>Looks good!</Form.Control.Feedback>}
                <Form.Control.Feedback type='invalid'>Enter a valid password</Form.Control.Feedback>
                <Form.Text id="passwordHelpBlock" muted>
                  Your password must be 8-20 characters long, contain letters, numbers,
                  and atleast one special characters without containing spaces or emoji.
                </Form.Text>
              </FloatingLabel>
            </Form.Group>
            <Col className='form-submit'>
              <Form.Group className='mb-3'>
                <Form.Check
                    label='Sign up to our email newsletter'
                    feedback='Want to know about special offers?'
                    feedbackType='valid'
                  />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Check
                    required
                    label='Agree to terms and conditions'
                    feedback='You must agree before submitting.'
                    feedbackType='invalid'
                  />
              </Form.Group>
            </Col>
            <Button type='outline-dark submit' variant='dark'>Sign Up</Button>
        </Form>
      </Container>
      <p>Already have an account? <a href='#/account'>Log in</a></p>
    </section>
  );
}